export default {
  homePage_00007: '待办事项',
  homePage_00020: '退款申请',
  homePage_00021: '个人发票申请',
  homePage_00022: '团体发票申请',
  homePage_00023: '缴费账单',
}